import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  margin: '60px 0',
  gap: '40px',
}));

export const PeptTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  margin: '20px 0',
  '& span': { color: theme.palette.secondary.main },
}));

export const PeptText = styled(Typography)(() => ({
  color: '#ec5353',
}));
